module.exports = __webpack_public_path__ + "cef9672243a0a4e587ecb1f1c72e3c4f.wav";